import type { HttpFetcherWithBaseUrl } from '~/shared/http-fetcher';
import type { TrackingEvent, TrackingEventName } from '~/shared/tracking/tracking';

export type InternalTrackingFetchers = {
    readonly sendTrackingEvent: (event: TrackingEvent) => void;
};

export type FeedbackFetchersDependencies = {
    readonly cobrainerApiFetcher: HttpFetcherWithBaseUrl;
};

const trackableEvents: readonly TrackingEventName[] = ['add-skill', 'remove-skill', 'detect-skills'];

export const createInternalTrackingFetchers = (
    dependencies: FeedbackFetchersDependencies,
): InternalTrackingFetchers => {
    const { cobrainerApiFetcher } = dependencies;

    const sendTrackingEvent: InternalTrackingFetchers['sendTrackingEvent'] = (payload) => {
        if (trackableEvents.includes(payload.name)) {
            cobrainerApiFetcher
                .postJson({
                    pathname: `/trace`,
                    payload,
                })
                .then()
                .catch(() => {
                    // Silently ignore tracking errors to avoid disrupting user experience
                });
        }
    };

    return {
        sendTrackingEvent,
    };
};
